import React, { useEffect, useState } from "react";
import api, { formatINR } from "@/lib/api";
import { Trophy, ArrowUp } from "lucide-react";

export default function LeaderboardCard() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/leaderboard").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d) return null;

  return (
    <div className="bg-white rounded-2xl border border-stone-200 p-6" data-testid="leaderboard-card">
      <div className="flex flex-wrap items-center gap-3 mb-4">
        <div className="flex items-center gap-2">
          <Trophy className="w-4 h-4 text-amber-600" />
          <h3 className="font-display text-lg font-black">Monthly Leaderboard</h3>
          <span className="text-xs text-stone-400">{d.month}</span>
        </div>
        <div className="ml-auto text-right">
          {d.my_rank ? (
            <div className="flex items-center gap-2">
              <span className="bg-emerald-900 text-amber-400 font-display font-black text-lg rounded-full px-4 py-1" data-testid="leaderboard-my-rank">#{d.my_rank}</span>
              <div className="text-left">
                <div className="text-[10px] font-bold uppercase text-stone-500">Your rank of {d.total_ranked}</div>
                <div className="text-xs font-mono font-bold">{formatINR(d.my_month_earned)} this month</div>
              </div>
            </div>
          ) : (
            <div className="text-xs text-stone-500" data-testid="leaderboard-unranked">Not ranked yet — close your first lead this month to enter the chart</div>
          )}
        </div>
      </div>
      {d.my_rank > 1 && d.gap_to_next != null && (
        <div className="mb-3 text-xs bg-amber-50 border border-amber-100 text-amber-900 rounded-lg px-3 py-2 inline-flex items-center gap-1.5" data-testid="leaderboard-gap">
          <ArrowUp className="w-3.5 h-3.5" /> Earn <b>{formatINR(d.gap_to_next)}</b> more to overtake rank #{d.my_rank - 1}
        </div>
      )}
      <div className="space-y-1.5">
        {d.top.length === 0 && <div className="text-sm text-stone-400 py-4 text-center">No earnings on the chart yet this month — be the first!</div>}
        {d.top.slice(0, 5).map((t) => (
          <div key={t.user_id} data-testid={`leaderboard-row-${t.rank}`}
            className={`flex items-center gap-3 rounded-xl px-3 py-2 ${t.is_me ? "bg-emerald-900 text-white" : "bg-stone-50"}`}>
            <span className={`w-7 h-7 rounded-full grid place-items-center text-xs font-black ${t.rank === 1 ? "bg-amber-500 text-white" : t.is_me ? "bg-amber-400 text-emerald-950" : "bg-white border border-stone-200 text-stone-600"}`}>
              {t.rank}
            </span>
            <span className="font-bold text-sm truncate">{t.name}{t.is_me && " (You)"}</span>
            <span className={`ml-auto font-mono font-bold text-sm ${t.is_me ? "text-amber-300" : "text-emerald-900"}`}>{formatINR(t.amount)}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
